import { useTranslation } from 'react-i18next';

import type { CustomCondition } from '~/api/conditions/types';

import { useDeleteCustomCondition } from '~/api/conditions';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  customCondition: CustomCondition;
  onClose: () => void;
};

export const ConfirmDeleteCustomConditionDialog = ({ customCondition, onClose }: Props) => {
  const deleteMutation = useDeleteCustomCondition();

  const { t } = useTranslation(['common', 'settings']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('settings:general.customConditions.delete.title')}</AlertDialog.Title>

      <AlertDialog.Description>
        {t('settings:general.customConditions.delete.description', { name: customCondition.name })}
      </AlertDialog.Description>

      <AlertDialog.Actions>
        <Button
          emphasis="status"
          icon="Trash"
          loading={deleteMutation.isPending}
          onClick={() =>
            deleteMutation.mutate(customCondition.id, {
              onSuccess: () => {
                onClose();
                toast.success({ description: t('settings:alerts.customConditions.successDeleted') });
              },
              onError: () => toast.danger({ description: t('common:error') }),
            })
          }
        >
          {t('settings:general.customConditions.delete.action')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
